import React from "react";

import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";

import Icon from "../../../../../../../../components/ui/icon/Icon";
import { PANEL_ADVANCED_PROP } from "../../../../../settings/features/panel-advanced/defaults";
import {
  Emoji,
  PanelContainer,
  PanelContent,
  PanelHeader,
  PanelHeading,
} from "./styles";

const Atlassian = ({ data, isPreview, text: { TextComponent } = {} }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const isEmoji = typeof data[PANEL_ADVANCED_PROP.ICON] === "object";

  return (
    <PanelContainer
      borderRadius={data[PANEL_ADVANCED_PROP.BORDER_RADIUS]}
      borderColor={data[PANEL_ADVANCED_PROP.COLORS].accent[theme.name]}
      backgroundColor={data[PANEL_ADVANCED_PROP.COLORS].accent[theme.name]}
    >
      <PanelHeader
        justifyContent={data[PANEL_ADVANCED_PROP.ALIGNMENT]}
        color={data[PANEL_ADVANCED_PROP.COLORS].accent[theme.name]}
      >
        {data[PANEL_ADVANCED_PROP.HAS_ICON] && (
          <>
            {isEmoji ? (
              <Emoji>{data[PANEL_ADVANCED_PROP.ICON].native}</Emoji>
            ) : (
              <Icon icon={data[PANEL_ADVANCED_PROP.ICON]} size="18px" />
            )}
          </>
        )}
        <PanelHeading textAlign={data[PANEL_ADVANCED_PROP.ALIGNMENT]}>
          {data[PANEL_ADVANCED_PROP.TITLE]}
        </PanelHeading>
      </PanelHeader>

      {isPreview && (
        <PanelContent
          justifyContent={data[PANEL_ADVANCED_PROP.ALIGNMENT]}
          color={theme.text.text}
        >
          --- {t("advanced-macro-content-placeholder")} ---
        </PanelContent>
      )}

      {TextComponent && !isPreview && (
        <PanelContent justifyContent={data[PANEL_ADVANCED_PROP.ALIGNMENT]}>
          {TextComponent}
        </PanelContent>
      )}
    </PanelContainer>
  );
};

export default Atlassian;
